import { IUserData } from './user';
import { IVideoInterviewData } from './videoInterviewData';

export enum UserVideoInterviewStatus {
  TODO = 'ToDo',
  STARTED = 'Started',
  SKIPPED = 'Skipped',
  FINISHED = 'Finished',
}

export interface IUserVideoInterviewData {
  id: string;
  userId: string;
  videoInterview: IVideoInterviewData | null;
  records: {
    questionNumber: number;
    fileName: string;
    attempt: number;
  }[];
  status: UserVideoInterviewStatus;
  sentDate: string;
  resultDate: string | null;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  isIndependentVI: boolean;
  reviewer: string | null;
  agent?: string;
}

export interface IViewUserVideoInterviewData {
  id: string;
  videoInterview: IVideoInterviewData;
  records: {
    questionNumber: number;
    fileName: string;
  }[];
  resultDate: string | null;
  agent?: string;
  user: Pick<IUserData, 'firstName' | 'lastName'>;
}
